import { render, staticRenderFns } from "./unit-objective-view.vue?vue&type=template&id=4764dfc0&scoped=true"
import script from "./unit-objective-view.ts?vue&type=script&lang=ts&external"
export * from "./unit-objective-view.ts?vue&type=script&lang=ts&external"
import style0 from "./unit-objective-view.less?vue&type=style&index=0&id=4764dfc0&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4764dfc0",
  null
  
)

export default component.exports